// Compatibility re-export: the chat SSE wire contract is shared by web and
// mobile through @ishvaram/api-client.
export {
  dispatchChatStreamEvent,
  drainChatStreamEvents,
  parseChatStreamEvent,
  streamChat,
} from "@ishvaram/api-client";
export type { ChatStreamEvent, ChatStreamHandlers, ChatStreamOptions } from "@ishvaram/api-client";
